import { put, call } from 'redux-saga/effects';
import { EndorsementActions } from '../Redux/EndorsementRedux';
import { EndorsementServiceType } from '../Services/EndorsementService';
import { ApiResponse } from 'apisauce';
import EndorsementDto from 'Models/Endorsement/Dto/EndorsementDto';
import UpdateEndorsementDto from 'Models/Endorsement/Dto/UpdateEndorsementDto';

interface EndorsementParams {
   type: string;
   id: string;
   updateData: UpdateEndorsementDto;
   contactId: string;
}

export function* getEndorsementHistoryById(
   endorsementService: Readonly<EndorsementServiceType>,
   action: Readonly<EndorsementParams>
): Generator {
   const { id } = action;

   yield put(EndorsementActions.getEndorsementHistoryByIdReset());

   const endorsementResponse = yield call(
      endorsementService.getEndorsementsHistoryById,
      id
   );
   const response = endorsementResponse as ApiResponse<EndorsementDto[]>;

   if (response.status && response.ok) {
      yield put(EndorsementActions.getEndorsementHistoryByIdSuccess(response.data));
   } else {
      yield put(
         EndorsementActions.getEndorsementHistoryByIdFailure({
            code: 'Error',
            status: response.status,
         })
      );
   }
}

export function* getActiveEndorsementsByContactId(
   endorsementService: Readonly<EndorsementServiceType>,
   action: Readonly<EndorsementParams>
): Generator {
   const { contactId } = action;

   const endorsementResponse = yield call(
      endorsementService.getActiveEndorsementsByContactId,
      contactId
   );
   const response = endorsementResponse as ApiResponse<EndorsementDto[]>;

   if (response.status && response.ok) {
      yield put(EndorsementActions.getActiveEndorsementsByContactIdSuccess(response.data));
   } else {
      yield put(
         EndorsementActions.getActiveEndorsementsByContactIdFailure({
            code: 'Error',
            status: response.status,
         })
      );
   }
}

export function* updateEndorsement(
   endorsementService: Readonly<EndorsementServiceType>,
   action: Readonly<EndorsementParams>
): Generator {
   const { updateData } = action;
   const endorsementResponse = yield call(
      endorsementService.updateEndorsement,
      updateData
   );
   const response = endorsementResponse as ApiResponse<EndorsementDto>;

   if (response.status && response.ok) {
      yield put(EndorsementActions.updateEndorsementSuccess(response.data));
   } else {
      yield put(
         EndorsementActions.updateEndorsementFailure({
            code: 'Error',
            status: response.status,
         })
      );
   }
}
